import { useEffect, useState } from 'react';

import { useApiRequest } from '@europrocurement/l2d-hooks';
import { useOffreService } from '@europrocurement/l2d-domain';
import {
    ApiCataloguesFullGetCollection200Response,
    CatalogueApi,
    CatalogueJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFullCatalogueReadGrilleTarifaireSurchargePrescripteur as LinkedCatalogueFull,
} from '@europrocurement/l2d-domain/openApi/ApiOffre';

export type LinkedCatalogue = LinkedCatalogueFull;

export type LinkedCataloguesStatus = 'idle' | 'loading' | 'succeeded' | 'failed';

/** Critère de rattachement des catalogues : par offre ou par package. */
export type LinkedCataloguesFilter = {
    offreId?: number;
    packageId?: number;
};

/**
 * Récupère les catalogues rattachés à une offre ou à un package, avec le détail
 * des surcharges d'articles posées au niveau de chaque catalogue (endpoint « full »).
 */
const useLinkedCatalogues = (filter: LinkedCataloguesFilter) => {
    const { offreId, packageId } = filter;
    const { catalogModel } = useOffreService();
    const { request } = useApiRequest<ApiCataloguesFullGetCollection200Response>();

    const [catalogues, setCatalogues] = useState<LinkedCatalogue[]>([]);
    const [status, setStatus] = useState<LinkedCataloguesStatus>('idle');

    useEffect(() => {
        if (!offreId && !packageId) {
            return undefined;
        }

        let active = true;
        setStatus('loading');

        request(
            (catalogModel.api as CatalogueApi).apiCataloguesFullGetCollection({
                offreId,
                packageId,
                itemsPerPage: 100,
            }),
            {
                withToaster: false,
                successCallback: (result) => {
                    if (active) {
                        setCatalogues(result.data['hydra:member'] ?? []);
                        setStatus('succeeded');
                    }
                },
                failureCallback: () => {
                    if (active) {
                        setStatus('failed');
                    }
                },
            },
        );

        return () => {
            active = false;
        };
    }, [offreId, packageId, catalogModel, request]);

    return { catalogues, status };
};

export default useLinkedCatalogues;
